import api from '@/utils/api';

/**
 * 提现相关接口
 */

/**
 * 获取提现列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 分页页码
 * @param {string} params.limit - 每页数量
 * @param {string} params.status - 状态筛选：pending / approved / rejected
 * @returns {Promise}
 */
export function getWithdrawRecords(params) {
  return api.get('/withdraw/records', {
    params: {
      page: params.page,
      limit: params.limit,
      status: params.status
    }
  });
}

/**
 * 提现申请
 * @param {Object} params - 提现参数
 * @param {number} params.amount - 提现金额
 * @param {string} params.method - 提现方式：wechat / alipay / bank
 * @returns {Promise}
 */
export function applyWithdraw(params) {
  const formData = new FormData();
  formData.append('amount', params.amount);
  formData.append('method', params.method);
  return api.post('/withdraw/apply', formData);
}

